import resource from "../i18n/resource.json";

export function translate(codification: string): string {
   const lang: string = localStorage.getItem("lang") ?? "fr";
   const wording: any = resource.find(
      item => item.Codification === codification,
   );
   return wording != null ? wording[lang] : codification;
}
